
/**
 * Custom error classes for authentication and permission issues
 */

// Custom error to handle authentication issues
export class AuthError extends Error {
  constructor(message = "Authentication required") {
    super(message);
    this.name = "AuthError";
  }
}

// Custom error to handle RLS policy violations
export class RLSError extends Error {
  constructor(message = "Row Level Security policy violation") {
    super(message);
    this.name = "RLSError";
  }
}
